import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import {
  selectIsUpdateRecipesCategory,
  selectRecipesCategoryForUpdate,
  selectRecipesCategoriesRefreshTable,
  setIsRecipesCategoryForUpdate,
  setRecipesCategoryForUpdate,
  RecipesCategoriesChangeModalState,
  updateRecipesCategory,
  refreshTableRecipesCategories,
  createRecipesCategory,
} from "../../../redux";
import { message } from "antd";

import { DataRecipesCategory } from "../../../redux/@types/recipesCategories";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { TableProperties } from "../../../shared/components/ui/Table/types";
// import { validateCreateRecipesCategory, validateUpdateRecipesCategory } from "../../../helpers";

export const useRecipesCategories = () => {
  const dispatch = useAppDispatch();

  const isUpdateRecipesCategory = useSelector(selectIsUpdateRecipesCategory);
  const dataUpdateRecipesCategory = useSelector(selectRecipesCategoryForUpdate);
  const isRefreshTableRecipesCategories = useSelector(
    selectRecipesCategoriesRefreshTable
  );

  const [isLoading, setIsLoading] = useState(false);
  const [tableProps, setTableProps] = useState<TableProperties>();

  const changeModalRecipesCategoriesState = () => {
    dispatch(setIsRecipesCategoryForUpdate(false));
    dispatch(RecipesCategoriesChangeModalState(true));
  };

  const formMethodsCreate = useForm<DataRecipesCategory>({
    // resolver: yupResolver(validateCreateRecipesCategory),
  });

  const formMethodsUpdate = useForm<DataRecipesCategory>({
    // resolver: yupResolver(validateUpdateRecipesCategory),
  });

  useEffect(() => {
    if (isUpdateRecipesCategory) {
      formMethodsUpdate.reset({ ...dataUpdateRecipesCategory });
    }
    return () => {
      formMethodsCreate.reset();
    };
  }, [isUpdateRecipesCategory, dataUpdateRecipesCategory]);

  const updateStatus = async (value: "active" | "inactive", id: any) => {
    if (isLoading) return;
    setIsLoading(true);
    await updateRecipesCategory({ id, status: value })
      .then((res: Partial<DataRecipesCategory>) => {
        setIsLoading(false);
        if (res && res.id) {
          message.success(
            `Se ha actualizado con éxito el estado de la categoría con id:${res.id}`
          );
          dispatch(refreshTableRecipesCategories(true));
        } else {
          message.error(res as string);
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        message.error(err.message);
      });
  };

  const onSubmitCreateOrUpdate = async (payload: DataRecipesCategory) => {
    if (isLoading) return;
    setIsLoading(true);
    if (isUpdateRecipesCategory) {
      await updateRecipesCategory({ ...payload })
        .then((res: Partial<DataRecipesCategory>) => {
          setIsLoading(false);
          if (res && res.id) {
            dispatch(RecipesCategoriesChangeModalState(false));
            message.success(
              `Se ha actualizado con éxito la categoría con id:${res.id}`
            );
            dispatch(refreshTableRecipesCategories(true));
          } else {
            message.error(res as string);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          message.error(err.message);
        });
    } else {
      await createRecipesCategory({ ...payload })
        .then((res: DataRecipesCategory) => {
          setIsLoading(false);
          if (res && res.id) {
            dispatch(RecipesCategoriesChangeModalState(false));
            message.success(
              `Se ha creado con éxito la categoría con id:${res.id}`
            );
            dispatch(refreshTableRecipesCategories(true));
          } else {
            message.error(res as any);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          message.error(err.message);
        });
    }
  };

  useEffect(() => {
    if (isRefreshTableRecipesCategories) {
      tableProps?.refresh();
      dispatch(refreshTableRecipesCategories(false));
    }
  }, [isRefreshTableRecipesCategories]);

  return {
    isUpdateRecipesCategory,
    isLoading,
    tableProps,
    formMethodsCreate,
    formMethodsUpdate,
    setTableProps,
    onSubmitCreateOrUpdate,
    changeModalRecipesCategoriesState,
    updateStatus,
  };
};
